import { FaCookieBite } from 'react-icons/fa';

import styles from './Preferences.module.css';

interface PreferencesProps {
  open: boolean;
  onToggle: () => void;
}

export default function Preferences({
  open,
  onToggle,
}: PreferencesProps): JSX.Element {
  return (
    <button
      className={styles.preferences}
      type="button"
      onClick={onToggle}
      aria-label="Preferências de cookies"
      title="Preferências de cookies"
      aria-expanded={open}
      aria-controls="analytics-consent"
    >
      <FaCookieBite size={30} aria-hidden="true" />
    </button>
  );
}
